import { Box, Dialog, DialogContent, Grid, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import frown from '../../../icons/fro.svg';

interface ErrorModalProps {
    open: boolean
}

const ErrorModal = (props: ErrorModalProps) => {
    const { open } = props;
    const isOnMobileScreen = useMediaQuery("(max-width:600px)");
    const style = {
        height: isOnMobileScreen ? "100%" : "523px",
    };

    return (
        <Dialog
            open={open}
            fullScreen={isOnMobileScreen}
            BackdropProps={{
                invisible: true,
            }}
            fullWidth={true}
            disableEnforceFocus
            style={{
                background: "none",
            }}
            PaperProps={{
                style: {
                    pointerEvents: "auto",
                    borderRadius: isOnMobileScreen ? "0px" : "24px",
                    width: isOnMobileScreen ? "100%" : "472px",
                    boxShadow: "none",
                    overflow: "hidden"
                },
            }}
            disableEscapeKeyDown={true}>
            <DialogContent>
                <Box sx={style}>
                    <Grid container display='flex' justifyContent='space-between' flexDirection='column' sx={{ height: '100%' }} >
                        <Grid item display="flex" flexDirection="column" alignItems={'center'}>
                            <Grid item display="flex" justifyContent='center' pb={3} mt={15}>
                                <img src={frown} alt='confirmation' />
                            </Grid>
                            <Grid item justifyContent='center'>
                                <Typography
                                    sx={{
                                        fontFamily: "Work Sans",
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        fontSize: '40px',
                                        lineHeight: '23px',
                                        color: '#757575',
                                        textAlign: 'center',
                                        marginTop: '10px'
                                    }}>
                                    404
                                </Typography>
                            </Grid>
                            <Grid mt={2} item justifyContent='center'>
                                <Typography
                                    sx={{
                                        fontFamily: "Work Sans",
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        fontSize: '20px',
                                        lineHeight: '23px',
                                        color: '#9E9E9E',
                                        textAlign: 'center',
                                        marginTop: '10px'
                                    }}>
                                    Page not found.
                                </Typography>
                            </Grid>
                            <Grid item justifyContent='center' mt={2} xs={8}>
                                <Typography
                                    sx={{
                                        fontFamily: "Work Sans",
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        fontSize: '12px',
                                        lineHeight: '23px',
                                        color: '#9E9E9E',
                                        textAlign: 'center',
                                        marginTop: '10px',
                                    }}>
                                    The page you are looking for does not exist or an other error occured.
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent >
        </Dialog>
    );
}
export default ErrorModal;